import {Component, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';
import {finalize} from "rxjs/operators";
import {Video} from "../../models/video.model";
import {BookmarkChange, DATE_FMT} from "../../defines/client.const";
import {GetCity2DisplayTxt, GetRegion2Css, GetRegion2Name, GetRegionCss} from "../../defines/desktop.const";
import {makeYoutubeUrl} from "../../defines/client.func";
import {VideoHistoryService} from "../../services/video/video-history.service";
import {VideoBookmarkService} from '../../services/video/video-bookmark.service';
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {VoiceService} from "../../services/voice/voice.service";


@Component({
  selector: 'app-video-box',
  styleUrls: ['./video-box.component.scss'],
  template: `
    <ng-container *ngIf="video">
      <div class="top-box">
        <div class="place-box">
          <article class="place-list-layout">
            <div class="place-label-list">
              <!-- div *ngIf="video.area1"
                   class="place-label-box main-type{{ GetRegion2Css(video.area1) }}">{{ GetRegion2Name(video.area1) }}</div -->

              <div *ngIf="video.area2"
                   class="place-label-box sub-type{{ GetRegion2Css(video.area1) }}">{{ video.area2 }}</div>

            </div>
          </article>
        </div>

        <div class="video-box">
          <div class="video type-1"
               style="background:url({{ makeYoutubeUrl(video.youtubeId) }}) no-repeat center/cover">
          </div>
        </div>

        <div class="badge-box"
             *ngIf="video.new">
          <i class="ic ic-new"></i>
        </div>

        <div class="option-box">
          <article class="bookmark-btn-box">
            <button type="button" class="bookmark-btn {{ getBmCss(video) }}"
                    (click)="ToggleBookmark($event, video)"></button>
          </article>
        </div>

      </div>

      <div class="bottom-box">
        <div class="listen-subject-box"
             [innerHTML]=" video.title | resize"></div>
        <div class="day-box">등록날짜 : {{ video.registered | date:DATE_FMT }}</div>
      </div>
    </ng-container>
  `,
})
export class VideoBoxComponent {
  @HostBinding('class') class = 'item-box';
  @Input() video?: Video;
  @Output() bookmarkChange = new EventEmitter<BookmarkChange>();

  protected readonly DATE_FMT = DATE_FMT;
  protected readonly makeYoutubeUrl = makeYoutubeUrl;
  protected readonly GetCity2DisplayTxt = GetCity2DisplayTxt;
  protected readonly GetRegion2Name = GetRegion2Name;
  protected readonly GetRegion2Css = GetRegion2Css;


  private sendingBookmark = false;

  constructor(
    protected historySvc: VideoHistoryService,
    protected bmSvc: VideoBookmarkService,
    protected voice: VoiceService,
    protected lm: LayoutMgrService,
    protected globalEventSvc: GlobalEventService,
  ) {

  }


  @HostListener('click', ['$event'])
  protected onOpenVideo(event: MouseEvent) {
    console.log('VideoBoxComponent::onOpenVideo()', this.video);
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    if (this.video?.no === undefined) {
      throw new Error('VideoBoxComponent::onOpenVideo() video.no is undefined');
    }
    this.historySvc.addHistory(this.video.no);

    // 소리 재생중이면 소리 중단
    this.voice.Stop();

    // 비디오 보기.
    this.lm.OpenYoutubePopup(this.video.youtubeId).subscribe(data => {
      console.log('VideoBoxComponent::onPlay() data', data);
    });
  }

  protected ToggleBookmark($event: MouseEvent, video: Video): void {
    console.log('VideoBoxComponent::ToggleBookmark()', video);
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (this.sendingBookmark) {
      return;
    }
    this.sendingBookmark = true;

    video.bookmark = !video.bookmark;
    this.bmSvc.sendBookmark(video.no, video.bookmark).pipe(
      finalize(() => this.sendingBookmark = false)
    ).subscribe(
      data => {
        console.log(data);
        this.bookmarkChange.emit({id: video.no, bookmark: video.bookmark});
      },
      err => console.error(err)
    );
  }

  protected getBmCss(video: Video): string {
    if (this.sendingBookmark) {
      return 'ing';
    }
    return video.bookmark ? 'on' : '';
  }
}
